$(document).ready(function () {
    let searchForm = $('.search-bar');
    let searchInput = searchForm.find('input');

    searchInput.on('keyup', debounce(500, function (e) {
        if ((e.keyCode >= 9 && e.keyCode <= 45) || (e.keyCode >= 91 && e.keyCode <= 93) || (e.keyCode >= 112 && e.keyCode <= 145)) {
            return;
        } else {
            let target = $(this);
            let value = target.val();
            let resultBox = target.closest('.search-bar').find('.search-bar-content');
            resultBox.find('.results').remove();
            if (value) {
                resultBox.removeClass('no-result loading');
                $.getJSON({
                    url: '/search?options%5Bprefix%5D=last&type=product&',
                    dataType: 'json',
                    type: 'POST',
                    data: {
                        q: value,
                        view: 'json'
                    },
                    beforeSend: function () {
                        resultBox.addClass('open loading');
                    },
                    success: function (data) {
                        let source = null;
                        let template = null;
                        let items = [];
                        let resp = {};
                        if (data.results_count === 0) {
                            resultBox.addClass('no-result');
                        } else {
                            resultBox.removeClass('no-result');
                            source = $('#searchAjax').html();
                            template = Handlebars.compile(source);
                            items = data.results.filter((item, index) => index <= 4);
                            let newItems = items.map(function(item, i , items) {

                                if(item.price){
                                    return {
                                        ...item,
                                        price: item.price.indexOf("<") != -1 ? $(item.price).text() : item.price,
                                        compare_at_price: item.compare_at_price.indexOf("<") != -1 ? $(item.compare_at_price).text() : item.compare_at_price
                                    }
                                }
                                else{
                                    return {
                                        ...item
                                    }
                                }
                            });

                            resp = {
                                items: [...newItems],
                            count: data.results_count,
                                urlShowAll: '/search?q=' + value
                        };

                            resultBox.append(template(resp));
                        }
                        resultBox.removeClass('loading');
                        update_currencies();
                        $(document).trigger("theme:spr:refresh");
                    }
                });
            } else {
                resultBox.removeClass('open loading');
            }
        }
    }));
});

function debounce(ms, f) {
    let timer = null;

    return function (...args) {
        const onComplete = () => {
            f.apply(this, args);
            timer = null;
        }

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(onComplete, ms);
    };
}